import { DialogObject } from '@/components/dialog/dialog.types';

export const getDynaDocsModelDeleteObject = ({ store, action, toggleVisiblity }: any): DialogObject => {
  return {
    title: 'settings.dynaDocsModels.delete.title',
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.dynaDocsModels.delete.delete',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'settings.dynaDocsModels.delete.cancel',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
